module.exports = __webpack_public_path__ + "img/DESIGN_01_prew.cdea5291.jpg";